import preval from 'babel-plugin-preval/macro';

const colors = preval`
const colors = require('../tailwind.config.ts').colors
module.exports = {
  ...colors
}`;
export default colors;
